import { ArrowDownThin } from '@ori-ui/icons';
const MuiSelect = {
  IconComponent: ArrowDownThin,
  variant: 'outlined',
  MenuProps: {
    elevation: 1
  }
};
export default MuiSelect;